import React, { useState } from "react";
import DocumentFile from "./DocumentFile.component";
import { ReactComponent as FileIcon } from "../../../../assets/Icons/Setting/Profile/FileIcon.svg";
import SecondModal from "../../../Universal/SecondModal.component";
import { ReactComponent as CrossBtnIcon } from "../../../../assets/Icons/Universal/CrossIcon.svg";
import DocumentFileUploadIcon from "../../../../assets/Icons/Setting/Profile/UploadFileIcon.svg";
import FormInput from "../../../Universal/FormInput.component";
import { Form, Formik } from "formik";

const FilesViewer = ({ data }) => {
  const [createFileModal, setCreateFileModal] = useState(false);
  return (
    <>
      <SecondModal isOpen={createFileModal} onClose={setCreateFileModal}>
        <div
          className="flex-col align-left justify-start g-2"
          style={{ width: "18rem" }}
        >
          <Formik
            initialValues={{
              fileName: "",
              file: null,
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ values, touched, errors, setFieldValue }) => (
              <Form className="w-full flex-col align-left justify-start g-2">
                <div className="flex-row align-center justify-between w-full">
                  <span className="t-13 poppins color-textColor">
                    Create files
                  </span>
                  <button
                    type="button"
                    className="transparentBtn flex align-center justify-center"
                    onClick={() => setCreateFileModal(false)}
                  >
                    <CrossBtnIcon style={{ width: "1rem", height: "1rem" }} />
                  </button>
                </div>

                <div className="w-full flex-col align-left justify-start g-1">
                  <div className="documentFileUploader">
                    {values.file && (
                      <span className="t-12 poppins color-folderColor">
                        {values.file.name}
                      </span>
                    )}
                    <div className="flex-row align-center justify-start g-05">
                      <img
                        src={DocumentFileUploadIcon}
                        alt=""
                        style={{ width: "1rem", height: "1rem" }}
                      />
                      <span className="t-12 poppins color-blueColor1">
                        {values.file === null
                          ? "Upload .PDF file here"
                          : "Upload another file here"}
                      </span>
                    </div>
                    <input
                      type="file"
                      name="upliadFile"
                      accept=".pdf"
                      onChange={(e) => {
                        setFieldValue("file", e.target.files[0]);
                      }}
                    />
                  </div>

                  <FormInput
                    type="text"
                    name="fileName"
                    label="File name"
                    placeholder="Enter file name"
                    touched={touched}
                    errors={errors}
                    className={"w-full"}
                    containerClass={"w-full"}
                  />
                </div>

                <button type="submit" className="actionBtn w-full">
                  Upload file
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </SecondModal>
      <div className="adminProfileDocumentContainer">
        <button
          type="button"
          className="createAdminProfileDocumentFile"
          onClick={() => setCreateFileModal(true)}
        >
          <FileIcon fill="#5e4de1" />

          <span className="t-14 poppins-medium">Create Files</span>
        </button>
        {data &&
          data?.map((fileData) => {
            return (
              <DocumentFile
                folderName={fileData.name}
                onDoubleClick={(e) => console.log("click")}
              />
            );
          })}
      </div>
    </>
  );
};

export default FilesViewer;
